var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5397 117H75.4766V62.8105H54.5397L54.5397 117Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2429 41.8018H96.1797V20.8649L75.2429 20.8649V41.8018Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0632 117H117V62.8105H96.0632V117Z",
    fill: "#004899"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3008 62.5028V41.5659H0.111305V62.5028H54.3008Z",
    fill: "#E53323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3008 20.9368V0L0.111305 0V20.9368L54.3008 20.9368Z",
    fill: "#004899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.e01eab20eb61988723905f69e9d00be9.svg";
export { ForwardRef as ReactComponent };